import type * as React from "react";
import LoadingSkeleton, { type SkeletonProps as LoadingSkeletonProps } from "react-loading-skeleton";
import { cn } from "src/utilities/shadcnUtils";

import LoadingSVG, { type LoadingSVGProps } from "./LoadingSVG";

// @ts-expect-error TODO there is a 'direction' property that doesn't matc
export interface SkeletonProps extends Omit<LoadingSkeletonProps, "style">, LoadingSVGProps {
  children?: React.ReactNode;
  dark?: boolean;
  className?: string;
  containerClassName?: string;
  inline?: boolean;
}

const Skeleton = ({ children, dark, className, containerClassName, inline, ...props }: SkeletonProps) => {
  if (children) {
    return (
      <LoadingSVG className={className} {...props}>
        {children}
      </LoadingSVG>
    );
  }
  return (
    <LoadingSkeleton
      className={className}
      containerClassName={cn(containerClassName, inline && "inline-block")}
      baseColor={dark ? "#636363" : "hsl(var(--muted))"}
      highlightColor={dark ? "#bababa" : "hsl(var(--muted-foreground) / 0.25)"}
      {...props}
    />
  );
};

export default Skeleton;
